export class CarserviceEstimate {
}
//# sourceMappingURL=car-service-estimate.js.map